import { jsx as s } from "react/jsx-runtime";
import { withManagedProps as N } from "@made-people/managed-props";
import { withZod as u } from "@made-people/react-prop-guard";
import { markdownBlueprint as f } from "./index-blueprint.es.js";
import { z as t } from "zod";
import g from "react-markdown";
import k from "rehype-raw";
import b from "remark-gfm";
import { useLink as w } from "@made-people/grease-link";
import y from "clsx";
import v from "striptags";
import "@made-people/blueprint";
const M = t.object({
  variants: t.custom().optional(),
  blueprint: t.custom().optional(),
  content: t.string().optional(),
  className: t.string().optional()
}), A = N(
  "Markdown",
  u(
    {
      schema: M,
      defaultProps: {}
    },
    ({ variants: m, blueprint: d, content: n, className: c }) => {
      const o = (d ?? f).styles(m), i = w();
      if (!n)
        return null;
      const h = (n.includes('class="language-markdown"') ? v(n) : n).replace(/&quot;/g, '"');
      return /* @__PURE__ */ s(
        g,
        {
          className: y(o.base, c),
          rehypePlugins: [k],
          remarkPlugins: [b],
          components: {
            ul: ({ node: a, depth: e, ordered: l, ...r }) => /* @__PURE__ */ s("ul", { className: o.ul, ...r }),
            ol: ({ node: a, depth: e, ordered: l, ...r }) => /* @__PURE__ */ s("ol", { className: o.ol, ...r }),
            li: ({ node: a, ordered: e, checked: l, index: r, ...p }) => /* @__PURE__ */ s("li", { className: o.li, ...p }),
            span: ({ node: a, ...e }) => /* @__PURE__ */ s("span", { className: o.span, ...e }),
            p: ({ node: a, ...e }) => /* @__PURE__ */ s("p", { className: o.p, ...e }),
            h1: ({ node: a, level: e, ...l }) => /* @__PURE__ */ s("h1", { className: o.h1, ...l }),
            h2: ({ node: a, level: e, ...l }) => /* @__PURE__ */ s("h2", { className: o.h2, ...l }),
            h3: ({ node: a, level: e, ...l }) => /* @__PURE__ */ s("h3", { className: o.h3, ...l }),
            h4: ({ node: a, level: e, ...l }) => /* @__PURE__ */ s("h4", { className: o.h4, ...l }),
            h5: ({ node: a, level: e, ...l }) => /* @__PURE__ */ s("h5", { className: o.h5, ...l }),
            h6: ({ node: a, level: e, ...l }) => /* @__PURE__ */ s("h6", { className: o.h6, ...l }),
            blockquote: ({ node: a, ...e }) => /* @__PURE__ */ s("blockquote", { className: o.blockquote, ...e }),
            hr: ({ node: a, ...e }) => /* @__PURE__ */ s("hr", { className: o.hr, ...e }),
            a: ({ node: a, ...e }) => /* @__PURE__ */ s(i, { className: o.a, ...e, href: e.href ?? "" }),
            strong: ({ node: a, ...e }) => /* @__PURE__ */ s("strong", { className: o.strong, ...e }),
            b: ({ node: a, ...e }) => /* @__PURE__ */ s("b", { className: o.strong, ...e }),
            em: ({ node: a, ...e }) => /* @__PURE__ */ s("em", { className: o.em, ...e }),
            code: ({ node: a, inline: e, ...l }) => /* @__PURE__ */ s("section", { className: o.code, ...l }),
            img: ({ node: a, ...e }) => /* @__PURE__ */ s("img", { className: o.img, ...e }),
            table: ({ node: a, ...e }) => /* @__PURE__ */ s("table", { className: o.table, ...e }),
            thead: ({ node: a, ...e }) => /* @__PURE__ */ s("thead", { className: o.thead, ...e }),
            tbody: ({ node: a, ...e }) => /* @__PURE__ */ s("tbody", { className: o.tbody, ...e }),
            tr: ({ node: a, isHeader: e, ...l }) => /* @__PURE__ */ s("tr", { className: o.tr, ...l }),
            th: ({ node: a, isHeader: e, ...l }) => /* @__PURE__ */ s("th", { className: o.th, ...l }),
            td: ({ node: a, isHeader: e, ...l }) => /* @__PURE__ */ s("td", { className: o.td, ...l }),
            pre: ({ node: a, ...e }) => /* @__PURE__ */ s("section", { className: o.pre, ...e })
          },
          children: h
        }
      );
    }
  )
);
export {
  A as Markdown,
  M as markdownSchema
};
//# sourceMappingURL=index.es.js.map
